export default "__VITE_ASSET__B9WGa9zy__"